import { render, staticRenderFns } from "./CorrespondenceDetails.vue?vue&type=template&id=6f064f62"
import script from "./CorrespondenceDetails.vue?vue&type=script&lang=js"
export * from "./CorrespondenceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports